import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js'
import React, { useEffect, useRef, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { log } from '../../../services/LogService'
import ErrorMsg from '../../ui/ErrorMsg'
import { ChartProps } from '../types'
import prepareChartData from '../utils/PrepareChartData'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default function MultiTypeChart({ endpoint, serverData, chartFor }: ChartProps) {
    const [className] = useState('MultiTypeChart-' + new Date().getTime())
    const chartRef = useRef<ChartJS>(null)
    const [chartData, setChartData] = useState({ datasets: [], labels: [] })
    const _options = serverData?.chartOptions?.multiType
    const [options, setOptions] = useState(_options)
    const _height = serverData?.chartOptions?.multiType?.chart?.canvas.height
    const [height, setHeight] = useState<string | number | undefined>(_height)

    try {
        useEffect(() => {
            const chart = chartRef.current
            if (!chart) {
                return
            }

            const { datasets, options, labels } = prepareChartData({
                chartType: 'multiType',
                endpoint,
                serverData,
                chart,
            })
            // @ts-ignore
            setChartData({ labels, datasets })
            setOptions(options)
            // log.info(className, 'MSG001', {serverData, labels, datasets})
        }, [chartFor, JSON.stringify(serverData)])

        // @ts-ignore
        return <Bar ref={chartRef} data={chartData} options={options} height={height} />
    } catch (e) {
        log.error(className, 'MSG001', { endpoint })
        return <ErrorMsg />
    }
}
